import { render, staticRenderFns } from "./PricingRulesConfig.vue?vue&type=template&id=e959ecce"
import script from "./PricingRulesConfig.vue?vue&type=script&lang=js"
export * from "./PricingRulesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports